import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { constObj } from '../../common/Constants/constants';
import { CommonDataService } from '../../common/services/common-data.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { LoginService } from '../../common/services/Login.service';
import { SessionService } from '../../common/services/Session.service';
import { ConfirmDialogComponent } from '../../common/shared-components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-redis-cache-management',
  templateUrl: './redis-cache-management.component.html',
  styleUrls: ['./redis-cache-management.component.css']
})
export class RedisCacheManagementComponent implements OnInit {

  constructor(public commonDataService: CommonDataService, private loginService: LoginService,
    private route: Router, private graphQlService: GraphqlService, private session: SessionService, public dialog: MatDialog) { }

  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.loginService.getSession().subscribe(data => {
        this.getRedisCacheLabels();
        if (this.session?.userInfo?.user?.isAdmin) {
          this.getRedisCacheLabels();
          this.host = window.location.host.split('.')[1] == "dev" ? "Development" : (window.location.host.split('.')[1] == "test" ? "Test" : "Production");
        } else {
          this.route.navigate(["/Home"]);
        }
        this.session.assignUserInfo(data.user);
      })
    }
    else {
      if (this.session?.userInfo?.user?.isAdmin) {
        this.getRedisCacheLabels();
        this.host = window.location.host.split('.')[1] == "dev" ? "Development" : (window.location.host.split('.')[1] == "test" ? "Test" : "Production");
      } else {
        this.route.navigate(["/Home"]);
      }
    }
  }
  host: string = "";
  showApplicationdefault;
  showEnvironmentdefault;
  redisCache_Header: string = "";
  redisCache_applicationDropdownHeader: string = "";
  redisCache_environmentDropdownHeader: string = "";
  redisCache_clearButton: string = "";
  redisCache_applicationsName: string = "";
  redisCache_environmentsName: string = "";
  redisCache_cleanUpText: string = "";
  applicationList = [];
  environmentList = [];
  getRedisCacheLabels() {
    this.graphQlService.getRedisCacheLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.redisCache_Header = labels.filter(x => x.key == "redisCache_Header").map(y => y.value);
        this.redisCache_applicationDropdownHeader = labels.filter(x => x.key == "redisCache_applicationDropdownHeader").map(y => y.value);
        this.redisCache_environmentDropdownHeader = labels.filter(x => x.key == "redisCache_environmentDropdownHeader").map(y => y.value);
        this.redisCache_clearButton = labels.filter(x => x.key == "redisCache_clearButton").map(y => y.value);
        this.redisCache_applicationsName = labels.filter(x => x.key == "redisCache_applicationsName").map(y => y.value);
        this.redisCache_environmentsName = labels.filter(x => x.key == "redisCache_environmentsName").map(y => y.value);
        this.redisCache_cleanUpText = labels.filter(x => x.key == "redisCache_cleanUpText").map(y => y.value);
        this.applicationList = this.redisCache_applicationsName[0].split(',');
        this.environmentList = this.redisCache_environmentsName[0].split(',');
        this.showApplicationdefault = new FormControl(this.applicationList[0]);
        this.showEnvironmentdefault = new FormControl(this.environmentList[0]);
        this.commonDataService.showLoader.next(false);
      }
    })
  }

  confirmClearRedisCache() {
    localStorage.setItem("isConfirmPopup", 'true');
    this.commonDataService.isConfirmationPopUpOpen.next(true);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '600px',
      data: constObj.redisCacheClearConfirmationMessage?.replace("{SITENAME}", `${this.host} ${this.showEnvironmentdefault.value}`)
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      localStorage.removeItem("isConfirmPopup");
      if (result == true) {
        this.ClearRedisCache();
      } else {
        return;
      }
    });
    return;
  }

  ClearRedisCache() {
    this.commonDataService.showLoader.next(true);
    this.graphQlService.clearRedisCache(this.showApplicationdefault.value, this.showEnvironmentdefault.value, window.location.host).toPromise()
      .then(response => {
        if (response == "Redis cache cleared successfully.") {
          let obj = {
            type: 'success',
            displayTime: 5000,
            position: 'bottom',
            message: constObj.redisCacheClearMessage + this.showApplicationdefault.value + " " + this.host + " " + this.showEnvironmentdefault.value
          }
          this.commonDataService.notificationObject.next(obj);
        }
        else {
          let obj = {
            type: 'error',
            displayTime: 5000,
            position: 'bottom',
            message: constObj.redisCacheClearFailedMessage
          }
          this.commonDataService.notificationObject.next(obj);
        }
        this.commonDataService.showLoader.next(false);
      })
      .catch(res => {
        console.log(res);
        this.commonDataService.showLoader.next(false);
      });
  }
}
